import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type WarningProps = IconComponentBaseProps;

export const Warning = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: WarningProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_9335_425037"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9335_425037)">
        <path
          d="M2.28364 13.6665C2.17064 13.6665 2.06914 13.6389 1.97914 13.5837C1.88914 13.5285 1.8192 13.4557 1.76931 13.3652C1.71731 13.2754 1.6887 13.1782 1.68347 13.0735C1.67825 12.9689 1.70647 12.8652 1.76814 12.7625L7.47531 2.90387C7.53708 2.80121 7.61431 2.72532 7.70697 2.67621C7.79975 2.6271 7.89742 2.60254 7.99997 2.60254C8.10253 2.60254 8.2002 2.6271 8.29297 2.67621C8.38564 2.72532 8.46286 2.80121 8.52464 2.90387L14.2318 12.7625C14.2935 12.8652 14.3217 12.9689 14.3165 13.0735C14.3113 13.1782 14.2826 13.2754 14.2306 13.3652C14.1808 13.4557 14.1108 13.5285 14.0208 13.5837C13.9308 13.6389 13.8293 13.6665 13.7163 13.6665H2.28364ZM2.96664 12.6665H13.0333L7.99997 3.99987L2.96664 12.6665ZM7.99997 11.8717C8.15253 11.8717 8.28042 11.8201 8.38364 11.7169C8.48686 11.6136 8.53847 11.4858 8.53847 11.3332C8.53847 11.1806 8.48686 11.0528 8.38364 10.9495C8.28042 10.8463 8.15253 10.7947 7.99997 10.7947C7.84742 10.7947 7.71953 10.8463 7.61631 10.9495C7.51308 11.0528 7.46147 11.1806 7.46147 11.3332C7.46147 11.4858 7.51308 11.6136 7.61631 11.7169C7.71953 11.8201 7.84742 11.8717 7.99997 11.8717ZM8.00014 10.128C8.14192 10.128 8.26064 10.0802 8.35631 9.98437C8.45208 9.88848 8.49997 9.76971 8.49997 9.62804V7.29471C8.49997 7.15304 8.45203 7.03432 8.35614 6.93854C8.26025 6.84265 8.14147 6.79471 7.99981 6.79471C7.85803 6.79471 7.73931 6.84265 7.64364 6.93854C7.54786 7.03432 7.49997 7.15304 7.49997 7.29471V9.62804C7.49997 9.76971 7.54792 9.88848 7.64381 9.98437C7.7397 10.0802 7.85847 10.128 8.00014 10.128Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
